import {createDataStore} from '@shared-web/lib/data_store';

const tmdbCountStore = createDataStore(0);
export const useTmdbCount = tmdbCountStore.useData;
export const updateTmdbCount = tmdbCountStore.updateData;
export const getTmdbCount = tmdbCountStore.getData;
